import { Button } from '@chakra-ui/react';
import { MdKeyboardBackspace } from 'react-icons/md';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from '../../../state/intl';

interface BackButtonProps {}

const BackButton: React.FC<BackButtonProps> = () => {
  const location = useLocation();
  const history = useHistory();
  const { lang } = useIntl();

  if (!location.pathname.slice(1).includes('/')) {
    return <div />;
  }

  return (
    <>
      <Button
        variant="ghost"
        leftIcon={<MdKeyboardBackspace style={{ fontSize: 26 }} />}
        color="gray.600"
        fontSize={16}
        onClick={history.goBack}
      >
        {
          {
            en: 'Back',
            it: 'Indietro',
            es: 'Back',
          }[lang]
        }
      </Button>
    </>
  );
};

export default BackButton;
